import { render, staticRenderFns } from "./EditarLocalProva.vue?vue&type=template&id=56c32e03"
import script from "./EditarLocalProva.vue?vue&type=script&lang=js"
export * from "./EditarLocalProva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports